import { render, staticRenderFns } from "./faqItemMainPage.vue?vue&type=template&id=4a877338&scoped=true"
import script from "./faqItemMainPage.vue?vue&type=script&lang=js"
export * from "./faqItemMainPage.vue?vue&type=script&lang=js"
import style0 from "./faqItemMainPage.vue?vue&type=style&index=0&id=4a877338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a877338",
  null
  
)

export default component.exports